/** Синхрон с проверкой на бэкенде (Manager и Zam всегда; дополнительные роли через Mongo); для SPA предпочтительно поле can_access_fleet_ai_analytics из /api/auth/me. */
export function normalizedPositionCanFleetAiAnalytics(normalized: string | null | undefined): boolean {
  return ['Manager', 'Zam'].includes((normalized || '').trim())
}
